module.exports = __webpack_public_path__ + "static/media/fondLanding.cea0ab6f.jpg";